import i18n from 'shared/lib/i18n';

export const getExportCancellationReason = () => ({
  manuallyCanceled: i18n.t('viewExport.manuallyCanceled'),
  error: i18n.t('viewExport.error'),
});
